var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1394_13784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7835 1.7186C10.8145 1.57312 10.7966 1.42145 10.7326 1.28719C10.6685 1.15293 10.5619 1.04359 10.4293 0.976157C10.2967 0.908729 10.1456 0.886992 9.99933 0.914325C9.8531 0.941658 9.72 1.01653 9.62071 1.1273L1.97071 9.6773C1.88384 9.77443 1.82694 9.89462 1.80688 10.0234C1.78681 10.1521 1.80444 10.2839 1.85764 10.4029C1.91083 10.5218 1.99732 10.6228 2.10666 10.6937C2.21599 10.7646 2.34351 10.8023 2.47381 10.8023H8.38861L7.21411 16.286C7.18309 16.4315 7.201 16.5832 7.26505 16.7174C7.3291 16.8517 7.43571 16.961 7.56831 17.0285C7.70091 17.0959 7.85207 17.1176 7.9983 17.0903C8.14452 17.063 8.27762 16.9881 8.37691 16.8773L16.0269 8.3273C16.1138 8.23018 16.1707 8.10999 16.1907 7.98125C16.2108 7.8525 16.1932 7.72069 16.14 7.60174C16.0868 7.48279 16.0003 7.38178 15.891 7.3109C15.7816 7.24003 15.6541 7.20231 15.5238 7.2023H9.60901L10.7835 1.7186Z",
    fill: "#8F69FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1394_13784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.a7ec2ffffb9f7352e92c4a7f478440ad.svg";
export { ForwardRef as ReactComponent };